export default "__VITE_ASSET__QgxFn$xq__"